import { FC } from 'react';

import Carousel from '@components/carousel';
import { buildSanityImageUrl } from '@lib/sanity/image';
import type { SanityTestimonialCard } from '@lib/sanity/types';

type TestimonialCardsProps = {
  testimonials: SanityTestimonialCard[];
};

const TestimonialCard: FC<SanityTestimonialCard> = ({
  quote,
  authorName,
  winDetail,
  authorImage
}) => {
  const imageUrl = authorImage
    ? buildSanityImageUrl(authorImage).width(80).height(80).url()
    : null;

  return (
    <div className="flex flex-col items-center rounded-lg border border-neutral-300 bg-white px-4 py-6 text-center">
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={authorName}
          className="mb-3 h-12 w-12 rounded-full object-cover"
        />
      ) : (
        <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-primary-50 text-base font-bold text-primary-600 font-heading">
          {authorName.charAt(0).toUpperCase()}
        </div>
      )}

      <p className="mb-3 text-sm italic leading-normal text-neutral-800 font-body">
        &ldquo;{quote}&rdquo;
      </p>

      <p className="text-sm font-bold text-neutral-800 font-body">
        {authorName}
      </p>

      {winDetail && (
        <p className="mt-0.5 text-xs text-neutral-500 font-body">{winDetail}</p>
      )}
    </div>
  );
};

const TestimonialCards: FC<TestimonialCardsProps> = ({ testimonials }) => {
  if (!testimonials || testimonials.length === 0) return null;

  return (
    <Carousel bullets slidesPerView={1} spaceBetween={16}>
      {testimonials.map((testimonial) => (
        <TestimonialCard key={testimonial._key} {...testimonial} />
      ))}
    </Carousel>
  );
};

export default TestimonialCards;
